var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart__content"},[_c('ve-pie',{attrs:{"data":_vm.chartData,"extend":_vm.chartExtend}}),_vm._v(" "),_c('div',{staticClass:"content__percent__title"},[_c('img',{attrs:{"src":"/static/images/congratulation/studying.png","alt":"studying"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.percentage))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd35357","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/curriculum/chartCurriculumExam.vue
// module id = null
// module chunks = 